import { AppStores } from '../../interfaces/appStore';

import { AppleIcon } from './storesIcon/AppleIcon';
import { HuaweiIcon } from './storesIcon/HuaweiIcon';

export const stores: AppStores = {
  appStore: {
    name: 'App Store',
    href: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/?placement=sravni_main_popup',
    icon: <AppleIcon />,
  },
  googlePlay: {
    name: 'Google Play',
    href: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/googleplay/?placement=sravni_main_banner',
  },
  huaweiAppGallery: {
    name: 'HUAWEI AppGallery',
    icon: <HuaweiIcon />,
    href:
      'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/huaweiAppGallery/?placement=sravni_main_popup_huaweiappgallery',
  },
};
